import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const CircleRadioFilledIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={21} height={21} viewBox="0 0 21 21" fill="none" {...props}>
      <circle
        cx="50%"
        cy="50%"
        r="10px"
        stroke="#BF295C"
        strokeWidth="1px"
        fill="none"
      />
      <circle cx="50%" cy="50%" r="4px" fill="#F56193" />
    </SvgIcon>
  );
};
